export const BaseSigningStatus = {
  signed: 'signed',
  unsigned: 'unsigned',
  in_queue: 'in_queue',
  error: 'error',
  signed_by_customer: 'signed_by_customer',
  signed_by_psp: 'signed_by_psp',
} as const;
export type BaseSigningStatusType = typeof BaseSigningStatus[keyof typeof BaseSigningStatus];
